import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const regulatoryClearanceHistory: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.REGULATORY_CLEARANCE_HISTORY,
  label: "Regulatory and clearance history",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "which licence, clearance, or check was involved",
    "what happened (denied, suspended, or revoked)",
    "when it happened",
    "the stated reason",
  ],
  followUpTriggers: [
    "the stated reason is unclear or missing",
    "the timeline is unclear",
  ],
  hardBarrierFacts: [
    "any professional licence, security clearance/reliability status, or vulnerable sector check revoked for cause",
  ],
  crossCuttingNotes: [
    "a direct eligibility signal for healthcare, social services, and federal roles — any 'yes' goes to human review regardless of severity",
    "being denied entry to another country, deported, or refused a visa is mostly informational unless the reason involved misrepresentation or criminal history",
  ],
};
